/* Important Info component on the Crew Info Edit Page */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";
import { Link } from "react-router-dom" 

const ImpoEditpage = () => {
  return (
    <div className="my-2">
      <Row className="mb-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
      <div className={`px-3 py-2 text-center  ${styles.SubTitle6}`}>
      <h5 className={`text-center ${styles.Red }`} >INFO</h5>  
      <hr className={`mt-2 mb-0`}/>
      <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> Click on a Department to open the Edit page containing the 
        Department's <span className={`${styles.Red}`}>Callsheet Main Crew</span> Positions.
      </p>
      <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> Input Crew members' details in their Positions and submit.
      </p>
      <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> Add the <span className={`${styles.Red}`}>Callname</span>, which displays in each position, on 
        the Add User form when registering the Crew members.
      </p>
      <hr className={`mt-2 mb-0`}/>
      </div>
      </Col>
    </Row>
    </div>
  )
}

export default ImpoEditpage